import { LockOutlined } from '@ant-design/icons';
import { isDemoTenant } from '@lib';
import React from 'react';

interface IProps {
  /** Just the padlock, for tight spots like table row actions. */
  compact?: boolean;
  style?: React.CSSProperties;
}

/** Matches the purple already used for the AI actions, so it reads as one product accent. */
const PAID_PURPLE = '#722ed1';

/**
 * Marks a feature a demo account can see but not use.
 *
 * Solid purple rather than an outline: this has to carry across a dark sidebar, coloured
 * buttons and white cards, and anything that inherits the surface colour disappears on at
 * least one of them. Green was ruled out — in a UI it reads as "available", which is the
 * opposite of what this says.
 *
 * Renders nothing for paying tenants, so it can be dropped in without a condition at the
 * call site.
 */
export const PaidOnlyTag: React.FC<IProps> = ({ compact = false, style }) => {
  if (!isDemoTenant()) return null;

  if (compact) {
    return <LockOutlined style={{ fontSize: 12, color: PAID_PURPLE, ...style }} />;
  }

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        background: PAID_PURPLE,
        color: '#fff',
        // Keeps it legible if it ever lands on a purple surface of its own.
        boxShadow: '0 0 0 1px rgba(255, 255, 255, 0.25)',
        borderRadius: 4,
        padding: '1px 6px',
        fontSize: 10,
        lineHeight: '14px',
        letterSpacing: 0.5,
        textTransform: 'uppercase',
        fontWeight: 600,
        whiteSpace: 'nowrap',
        ...style,
      }}
    >
      <LockOutlined style={{ fontSize: 9 }} />
      Paid
    </span>
  );
};
